module.exports = {
	"config": {
		"siteTitle": "dasProject"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.md",
				"ext": "md",
				"name": "about",
				"extname": ".md",
				"basename": "about.md",
				"dirname": "",
				"stem": "about",
				"path": "about.md"
			},
			"requirePath": "about.md",
			"path": "/about/",
			"data": {
				"title": "dasProject – Leben mit Beeinträchtigung"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "alex.js",
				"ext": "js",
				"name": "alex",
				"extname": ".js",
				"basename": "alex.js",
				"dirname": "",
				"stem": "alex",
				"path": "alex.js"
			},
			"requirePath": "alex.js",
			"path": "/alex/",
			"data": {
				"color": "blue",
				"number": 1
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "band.js",
				"ext": "js",
				"name": "band",
				"extname": ".js",
				"basename": "band.js",
				"dirname": "",
				"stem": "band",
				"path": "band.js"
			},
			"requirePath": "band.js",
			"path": "/band/",
			"data": {
				"color": "green",
				"number": 6
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "bassam.js",
				"ext": "js",
				"name": "bassam",
				"extname": ".js",
				"basename": "bassam.js",
				"dirname": "",
				"stem": "bassam",
				"path": "bassam.js"
			},
			"requirePath": "bassam.js",
			"path": "/bassam/",
			"data": {
				"color": "yellow",
				"number": 7
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "felix.js",
				"ext": "js",
				"name": "felix",
				"extname": ".js",
				"basename": "felix.js",
				"dirname": "",
				"stem": "felix",
				"path": "felix.js"
			},
			"requirePath": "felix.js",
			"path": "/felix/",
			"data": {
				"color": "hotpink",
				"number": 4
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "flo.js",
				"ext": "js",
				"name": "flo",
				"extname": ".js",
				"basename": "flo.js",
				"dirname": "",
				"stem": "flo",
				"path": "flo.js"
			},
			"requirePath": "flo.js",
			"path": "/flo/",
			"data": {
				"color": "orange",
				"number": 2
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "impressum.md",
				"ext": "md",
				"name": "impressum",
				"extname": ".md",
				"basename": "impressum.md",
				"dirname": "",
				"stem": "impressum",
				"path": "impressum.md"
			},
			"requirePath": "impressum.md",
			"path": "/impressum/",
			"data": {
				"title": "Impressum"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "lisa.js",
				"ext": "js",
				"name": "lisa",
				"extname": ".js",
				"basename": "lisa.js",
				"dirname": "",
				"stem": "lisa",
				"path": "lisa.js"
			},
			"requirePath": "lisa.js",
			"path": "/lisa/",
			"data": {
				"color": "cornflowerblue",
				"number": 5
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "matthias.js",
				"ext": "js",
				"name": "matthias",
				"extname": ".js",
				"basename": "matthias.js",
				"dirname": "",
				"stem": "matthias",
				"path": "matthias.js"
			},
			"requirePath": "matthias.js",
			"path": "/matthias/",
			"data": {
				"color": "red",
				"number": 3
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "niklas.js",
				"ext": "js",
				"name": "niklas",
				"extname": ".js",
				"basename": "niklas.js",
				"dirname": "",
				"stem": "niklas",
				"path": "niklas.js"
			},
			"requirePath": "niklas.js",
			"path": "/niklas/",
			"data": {
				"color": "purple",
				"number": 8
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "tini.js",
				"ext": "js",
				"name": "tini",
				"extname": ".js",
				"basename": "tini.js",
				"dirname": "",
				"stem": "tini",
				"path": "tini.js"
			},
			"requirePath": "tini.js",
			"path": "/tini/",
			"data": {
				"color": "coral",
				"number": 9
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0